import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import api from "../api";
import { Reveal } from "./motion";

const GRADIENTS = [
  "linear-gradient(135deg,#5865F2,#06B6D4)",
  "linear-gradient(135deg,#8B5CF6,#EC4899)",
  "linear-gradient(135deg,#F97316,#EF4444)",
  "linear-gradient(135deg,#10B981,#06B6D4)",
];

export default function BoosterStrip() {
  const [boosters, setBoosters] = useState([]);

  useEffect(() => {
    api.get("/public/boosters").then((r) => setBoosters(r.data.boosters || [])).catch(() => {});
  }, []);

  if (!boosters.length) return null;

  return (
    <section className="border-b border-white/10 bg-[#07070c] py-14" data-testid="booster-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex items-center gap-3 mb-8">
          <Rocket size={18} className="text-volt" />
          <p className="text-xs uppercase tracking-[0.35em] text-volt font-semibold">Wall of boosters</p>
          <span className="text-xs font-mono text-white/30">{boosters.length} legend{boosters.length === 1 ? "" : "s"} keeping the groove alive</span>
        </Reveal>
        <div className="flex flex-wrap gap-3">
          {boosters.map((name, i) => (
            <Reveal key={name} delay={i * 0.05}>
              <span
                className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-heading font-bold text-white border border-white/10"
                style={{ background: GRADIENTS[i % GRADIENTS.length] }}
                data-testid={`booster-${name}`}
              >
                <Rocket size={13} />
                {name}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
